import { http } from '@/utils/http'
/**桌台列表接口 */
interface table {
  orderId: string
  noNum: string
  createTime: string
  startCookFlag: number
  startTime: string
  tableInfo: string
}
/**桌台菜品信息 */
interface sku {
  /** 退菜标识 */
  backSkuFlag: number
  /** 创建人 */
  createBy: string
  /** 创建时间 */
  createTime: string
  /** 菜品名称 */
  dishesName: string
  /** 规格名称 */
  guiGeName: string
  /** id */
  id: string
  /** 是否完成配菜 */
  isCompleteDishes: number
  /** 是否单规格 */
  isOneFlag: number
  /** 是否出菜 */
  isOutDishes: number
  /** 菜品备注 */
  note: string
  /** 数量 */
  num: number
  /** 操作类型 */
  operaType: number
  /** 整单备注 */
  remark: string
  /** 同款菜品列表 */
  sameSkuKDSList: any[]
  /** 显示标识 */
  showFlag: number
  /** 起菜标识 */
  startCookFlag: number
  /** 开始做菜时间 */
  startTime: string
  /** 桌台信息 */
  tableInfo: string
  /** 更新人 */
  updateBy: string
  /** 更新时间 */
  updateTime: string
  /** 赠菜标识 */
  zenSkuFlag: number
}
/** 按桌台查看桌台列表 */
export const orderSkuListByTable = (data: any) => {
  return http.post<Array<table>>('/orderSkuKDSApi/showOrderSkuTableList', data)
}
/** 按桌台查看桌台菜品信息 */
export const orderSkuListByTableSku = (data: any) => {
  return http.post<Array<sku>>('/orderSkuKDSApi/showOrderSkuTableSku', data)
}
/** 按桌台查看挂起菜品 */
export const orderSkuListByTableHangUp = (data: any) => {
  return http.post<Array<sku>>('/orderSkuKDSApi/showOrderSkuTableHangUp', data)
}

/** 按菜品查看订单列表 */
export const orderSkuListByDishes = (data: any) => {
  return http.post<any>('/orderSkuKDSApi/showOrderSkuDishesList', data)
}
/** 按菜品查看订单菜品信息 */
export const orderSkuListByDishesSku = (data: any) => {
  return http.post<any>('/orderSkuKDSApi/showOrderSkuDishesSku', data)
}
/** 查看历史订单菜品信息 */
export const orderSkuListByHistory = (data: any) => {
  return http.post<any>('/orderSkuKDSApi/showHistoryKDSInfo', data)
}
//获取档口配置
export function getDeviceList(data: any) {
  return http({
    url: '/shop/printer/list',
    method: 'GET',
    query: data,
  })
}

/** 设置配菜状态 */
export const configDishes = (data: any) => {
  return http.post<any>('/orderSkuKDSApi/configDishes', data)
}

/** 设置出菜状态 */
export const outDishes = (data: any) => {
  return http.post<any>('/orderSkuKDSApi/outDishes', data)
}

/** 设置挂起状态 */
export const setHandUp = (data: any) => {
  return http.post<any>('/orderSkuKDSApi/setHandUpFlag', data)
}
/** 获取tts语音 */
export const getTts = (data: any) => {
  return http.get<any>('/shop/tts/voice', data)
}
